import React, { memo } from 'react';

// prettier-ignore
const Memoized = memo(props => {
    const {
        item,
        kind,
        drag,
        referred,
        dragSnapshot,
        itemIsClickable,
        itemIsActiveCheck,
        itemRenderer,
        handleRenderer
    } = props;

    const { isDragging } = dragSnapshot;

    return (
        <div
            {...{
                ...drag.draggableProps,
                ...(
                    handleRenderer
                        ? {}
                        : drag.dragHandleProps
                ),
                className:
                    `list-grid-item ${
                        kind || 'generic'
                    } ${
                        itemIsActiveCheck?.(item) ? 'is' : 'not'
                    }-active ${
                        itemIsClickable ? 'is' : 'not'
                    }-clickable ${
                        isDragging ? 'is' : 'not'
                    }-dragged`,
                ref:
                    el => {
                        if (isDragging) {
                            referred.draggedNode = el;
                        }
                        drag.innerRef(el);
                    }
            }}
        >
            {handleRenderer
                ? <div {
                    ...{
                        ...drag.dragHandleProps,
                        className: 'drag-handler'
                    }
                  }>
                    {handleRenderer?.(item)}
                  </div>
                : null
            }
            {itemRenderer(item)}
        </div>
    );
});

export default Memoized;
